import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";
import axios from "axios";

export default function Portfolio() {
  const [portfolios, setPortfolios] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [portfolioSection, setPortfolioSection] = useState(null);

  useEffect(() => {
    // Fetch Portfolio Section Data
    axios
      .get("https://solanthegroup.com/admin/api/portfolio_section")
      .then((response) => {
        setPortfolioSection(response.data[0]); // Setting Portfolio Section Data
      })
      .catch((error) => console.error("Error fetching section data:", error));

    // Fetch Portfolio Data
    axios
      .get("https://solanthegroup.com/admin/api/portfolios")
      .then((response) => {
        setPortfolios(response.data);
        const uniqueCategories = [
          "all",
          ...new Set(response.data.map((item) => item.categories.string)),
        ];
        setCategories(uniqueCategories);
      })
      .catch((error) => console.error("Error fetching portfolios:", error));
  }, []);

  const filteredPortfolios =
    activeCategory === "all"
      ? portfolios
      : portfolios.filter((item) => item.categories.string === activeCategory);

  return (
    <div>
      {portfolioSection?.status === "on" && (
        <div className="tmp-portfolio-area mt-5 pt-5 mb-5 pb-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-head text-center  d-flex flex-column justify-content-center align-items-center">
                  <div className="section-sub-title ">
                    <img
                      src="assets/images/services/section-custom-menubar.png"
                      alt="Portfolio"
                    />
                    <span>{portfolioSection.info_title}</span>
                  </div>
                  <h2 className="title">{portfolioSection.title}</h2>
                </div>
              </div>
            </div>

            <Tab.Container id="portfolio-tabs" defaultActiveKey="all">
              <Row>
                <Col sm={12}>
                  <Nav
                    variant="pills"
                    className="tmp-mesonary-area-main main-isotop d-flex justify-content-center mb-4"
                  >
                    {categories.map((category, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link
                          eventKey={category}
                          onClick={() => setActiveCategory(category)}
                          className="btn btn-outline-dark mx-2"
                          style={{fontSize:"16px"}}
                        >
                          {category === "all" ? "All" : category}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Col>

                <Col sm={12}>
                  <Tab.Content>
                    <Tab.Pane eventKey={activeCategory}>
                      <div className="row g-4">
                        {filteredPortfolios.length > 0 ? (
                          filteredPortfolios.map((portfolio) => (
                            <div
                              key={portfolio.id}
                              className="col-lg-4 col-md-6 col-sm-12"
                            >
                              <div className="tmp-single-portfolio-item">
                                <Link
                                  to={`/ProjectDetails?id=${portfolio.id}`}
                                  className="thumbnail"
                                >
                                  <img
                                    src={`https://solanthegroup.com/admin/${portfolio.photo}`}
                                    alt={portfolio.title}
                                    className="img-fluid"
                                  />
                                </Link>
                                <div className="tmp-inner-content p-3">
                                  <div className="top-item">
                                    <span className="left">
                                      {portfolio.categories.string}
                                    </span>
                                  </div>
                                  <Link to={`/ProjectDetails?id=${portfolio.id}`}>
                                    <h2 className="title">{portfolio.title}</h2>
                                  </Link>
                                  <p
                                    className="description"
                                    dangerouslySetInnerHTML={{
                                      __html: portfolio.description
                                        .split(" ")
                                        .slice(0, 20)
                                        .join(" "),
                                    }}
                                  ></p>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="col-12 text-center">
                            <h5>No Portfolio Found</h5>
                          </div>
                        )}
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
      )}
    </div>
  );
}
